var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccept = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "accept (1) 1",
    clipPath: "url(#clip0_7098_156487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 0.5C2.46641 0.5 0 2.96641 0 6C0 9.03359 2.46641 11.5 5.5 11.5C8.53359 11.5 11 9.03359 11 6C11 2.96641 8.53359 0.5 5.5 0.5Z",
    fill: "#F0BA15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.44082 8.51581C3.73828 7.81328 3.04004 7.10429 2.33535 6.40175C2.25801 6.32441 2.25801 6.1955 2.33535 6.11816L3.14531 5.3082C3.22266 5.23085 3.35156 5.23085 3.42891 5.3082L4.58691 6.46621L7.56465 3.48632C7.64414 3.40898 7.7709 3.40898 7.85039 3.48632L8.6625 4.29843C8.74199 4.37792 8.74199 4.50468 8.6625 4.58203L4.72441 8.51581C4.64707 8.59531 4.52031 8.59531 4.44082 8.51581Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7098_156487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccept);
export default ForwardRef;